/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Link } from 'react-router-dom'
import { DatePicker, Radio, Select, Button, Input, message, Spin } from 'antd'
import moment from 'moment'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import Report from './report'
import ModalSn from './modalSn'
import './style.css'
const { RangePicker } = DatePicker
const Option = Select.Option
const Search = Input.Search

export default class extends React.Component {
  state = {
    size: '0',
    visible: false,
    record_type: '',
    payment_id: '',
    loading: false,
    club_id: '',
    radioValue: 2,
  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  handleChange = (value) => {
    this.setState({ record_type: value })
    this.props.fetchPaymentList(value) //支付方式
  }

  paymentSelect = (value) => {
    this.setState({ payment_id: value })
  }

  handleButton = (type) => {
    if (this.state.record_type.length > 0) {
      let payment_id = ''
      if (this.state.payment_id.length > 0) {
        //判断是否为空
        payment_id = +this.state.payment_id
      }
      let data = {
        recharge: +this.state.record_type,
        start_time:
          moment(this.props.period.start_time).format('YYYY-MM-DD HH:mm:ss') ||
          '',
        end_time:
          moment(this.props.period.end_time).format('YYYY-MM-DD HH:mm:ss') ||
          '',
        type: payment_id,
        club_id: this.state.club_id,
        statisticType: this.state.radioValue,
      }
      this.setState({ loading: true })
      this.props.fetchIncomeBusiness(data).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      message.info('请选择记录')
    }
  }

  onChangeNumber = (e) => {
    this.setState({ number: e.target.value })
  }

  handleOk = () => {
    this.setState({ visible: false })
  }
  handleCancel = () => {
    this.setState({ visible: false })
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const { size, record_type, number } = this.state
    const {
      paymentList,
      period,
      business,
      recordDetail,
      clubList = [],
    } = this.props
    return (
      <div>
        <div className="business">
          <div className="business-left">
            <Radio.Group
              value={size}
              onChange={this.handleSizeChange}
              style={{ display: 'block', marginBottom: '1rem' }}
            >
              <Radio.Button value="1">昨日</Radio.Button>
              <Radio.Button value="2">今日</Radio.Button>
              <Radio.Button value="3">上月</Radio.Button>
              <Radio.Button value="4">本月</Radio.Button>
              <Radio.Button value="5">去年</Radio.Button>
              <Radio.Button value="6">今年</Radio.Button>
            </Radio.Group>
            <RangePicker
              // showTime={{
              //   defaultValue: [
              //     moment('09:00', 'HH:mm'),
              //     moment('09:00', 'HH:mm'),
              //   ],
              // }}
              format="YYYY-MM-DD"
              placeholder={['开始时间', '结束时间']}
              value={
                period.start_time
                  ? [
                    moment(`${period.start_time}`, 'YYYY-MM-DD'),
                    moment(`${period.end_time}`, 'YYYY-MM-DD'),
                  ]
                  : null
              }
              onChange={this.onChange}
            />
            <NineAndZeroRadio typeEvent={this.onTypeEvent} />
            <Select
              style={{ width: 200, marginTop: '1rem', display: 'block' }}
              placeholder="选择记录"
              onChange={this.handleChange}
            >
              <Option value="0">全部</Option>
              <Option value="1">消费记录</Option>
              <Option value="2">充值记录</Option>
              <Option value="3">卡券记录</Option>
            </Select>
            <Select
              style={{ width: 200, marginTop: '1rem', display: 'block' }}
              placeholder="选择支付方式,可以不选择"
              onChange={(value) => this.paymentSelect(value)}
            >
              <Option value="">全部</Option>
              {paymentList.map((item) => {
                return (
                  <Option value={item.id} key={item.id}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
            <div style={{ marginTop: '1rem' }}>
              <Button type="primary" onClick={() => this.handleButton()}>
                {/*<Link to={'/home/ClubBusiness/Report/'+ record_type}>显示</Link>*/}
                显示
              </Button>
            </div>
          </div>

          {/*<div className="business-right">*/}
          {/*<p style={{lineHeight: '2rem'}}>订单号查记录:</p>*/}
          {/*<Search*/}
          {/*placeholder="请输入订单号查询"*/}
          {/*style={{ width: 200 }}*/}
          {/*onSearch={value =>{this.props.fetchSnDetails(value);this.setState({visible: true})}}*/}
          {/*/>*/}
          {/*</div>*/}
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Report
            list={business}
            period={period}
            record_type={record_type}
            recordDetail={recordDetail}
            fetchRecordDetails={this.props.fetchRecordDetails}
          />
        )}
        <ModalSn
          {...this.state}
          list={recordDetail}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Consume/component/business.js